import { NestjsGetRequest } from 'nestjs-model-utility';
import { CaslRuleApiRoute } from 'src/domains/authentication/app/api-route/casl-rule/casl-rule.api';
import { CaslRuleModel } from 'casl-authorize';

export namespace CaslRuleRequest {
  export class List extends NestjsGetRequest<CaslRuleModel.Full, false> {
    _api = CaslRuleApiRoute;
    cache: false = false;
  }
}
